module.exports = __webpack_public_path__ + "static/media/filter-sidebar-assignee.a9d5d427.svg";